
import {Card, CardBody, CardTitle} from "reactstrap";
import TextTransition, { presets } from "react-text-transition";
import { timeFormatter } from "utils/formaters";
import moment from "moment";

export default function MeasureBox({title,value,timestamp,unit,onClick,alert,disabled}) {
    const fontSize= window.innerWidth < 1300 ? '28px' : '40px'
    const padding= window.innerWidth < 1300 ? '10px' : '15px'
    const opacity = disabled ? 0.2 : 1

    const empty = (value=== '---' || !value || Number(value) < 1)
    const floatValue = !empty && typeof value === 'string'  && (!Number(value.split('.')[1])?value.split('.')[0]:`${parseFloat(value).toFixed(1)}`)
    let displayValue = !empty ? floatValue||value : "---"

    return (
        <Card className="card-stats mb-4 mb-xl-0" onClick={()=>onClick(title)} style={Object.assign({cursor:'pointer'},alert?{border:'3px solid #f5365c'}:{})} >
            <CardBody style={{padding:'3px 16px'}} >

                <CardTitle className="text-center" style={{marginBottom:'5px', opacity}} >
                    {title}
                </CardTitle>

                <div className="row justify-content-center align-items-center" style={{ height:'100px'}} >
                    <div className="col col-auto lead " style={{fontSize,marginTop:'0px',padding:0, opacity, color:alert?"#f5365c":'inherit'}} > 
                            <TextTransition springConfig={ presets.wobbly } text={displayValue}/>
                    </div>
                
                    <div className="col col-auto" style={{padding,display:'inline-block',fontSize:'10px',paddingTop:unit?padding:'0px'}}>
                        <img alt="title" src={require(`../../assets/img/icons/${title}${disabled?' disabled':''}.svg`).default} height={fontSize} />
                        <div className="text-center text-muted" style={{opacity}}>
                            {unit}
                        </div>
                    </div>
                </div>
                
                <div className="text-center text-muted" style={{opacity,height:title === 'Pulse Rate' || title === 'Respiratory Rate' ? 21: title === 'Blood Pressure'?21:'' }} >
                      <small style={{display: title === 'Pulse Rate' || title === 'Respiratory Rate' ? 'none':'block'}}>
                            {(empty || !timestamp) ? '---' : (title === 'Weight') ? moment(timestamp).format('MMM DD') : timeFormatter(timestamp)}
                      </small>
                </div>
            </CardBody>
        </Card>
    )
}
